import React from "react";
import { motion } from "framer-motion";
import { Drama, Clapperboard, PenLine, ClipboardList, Palette, Camera, Award, Users, CalendarDays, Sparkles } from "lucide-react";

const ROLE_ICONS = [Drama, Clapperboard, PenLine, ClipboardList, Palette, Camera];
const REASON_ICONS = [Sparkles, Drama, Award, CalendarDays, Users, Camera];

export default function WhyUsSection({ content }) {
  const roleItems = (content.why_us_roles || []).map((label, i) => ({ label, icon: ROLE_ICONS[i % ROLE_ICONS.length] }));
  const reasonItems = (content.why_us || []).map((r, i) => ({ ...r, icon: REASON_ICONS[i % REASON_ICONS.length] }));
  return (
    <section id="why-us" data-testid="why-us-section" className="py-20 md:py-28 bg-[#1A0F0E] relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.06] bg-[radial-gradient(circle_at_20%_30%,#F0E8DB,transparent_40%)]" />
      <div className="max-w-7xl mx-auto px-4 sm:px-8 relative">
        <div className="text-center mb-10">
          <div className="text-[#F0E8DB] text-xs tracking-[0.4em] font-serif-en mb-3">WHY US</div>
          <h2 className="section-title text-3xl sm:text-4xl lg:text-5xl">{content.titles.why_us}</h2>
          {content.why_us_intro && <p className="text-[#A89A88] mt-4 max-w-2xl mx-auto">{content.why_us_intro}</p>}
          <div className="w-24 h-px bg-gradient-to-r from-transparent via-[#F0E8DB] to-transparent mx-auto mt-6" />
        </div>

        <div data-testid="why-us-roles" className="flex flex-wrap justify-center gap-3 mb-14">
          {roleItems.map((r) => (
            <div key={r.label} className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#F0E8DB]/30 text-[#F0E8DB] text-sm bg-[#241615]">
              <r.icon size={15} className="text-[#F0E8DB]" /> {r.label}
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasonItems.map((r, i) => (
            <motion.div
              key={r.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              data-testid={`why-us-card-${i}`}
              className="theater-card rounded-2xl p-7 group hover:border-[#F0E8DB]/60 transition-colors"
            >
              <div className="w-12 h-12 rounded-lg bg-[#7A2E2A]/30 border border-[#F0E8DB]/40 flex items-center justify-center mb-5 group-hover:bg-[#7A2E2A]/60 transition-colors">
                <r.icon className="text-[#F0E8DB]" size={22} />
              </div>
              <h3 className="text-[#F0E8DB] font-semibold text-xl mb-2">{r.title}</h3>
              <p className="text-[#C5B8A8] text-sm leading-loose">{r.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
